module.exports = __webpack_public_path__ + "media/images/common/icon-phone-white-938e719479532d999ee21d58283fc04c.png";